import Link from "next/link";
import CelebrityImage from "../celebrity-image";

function CelebrityCard({ data }) {
  return (
    <Link href={`${data.uri}`}>
      <a className="c-card-tow" style={{ maxWidth: "500px" }}>
        <div className="img-wrapper">
          {
            <CelebrityImage
              firstName={data.title}
              coverImage={data.featuredImage}
              imgWidth={1200}
              imgHeight={1200}
            />
          }
        </div>
        <div className="content-wrapper">
          <div className="c-card-tow-title-wrapper mb-3">
            <h3 className="c-card-tow-title">{data.title}</h3>
          </div>
          <article>
            <div
              className="content-title mb-3"
              dangerouslySetInnerHTML={{ __html: data.excerpt }}
            />
          </article>
        </div>
      </a>
    </Link>
  );
}

export default CelebrityCard;
